import React from "react";
import { View, Text } from "@react-pdf/renderer";

interface CircularProgressBarProps {
  percent: number;
  size?: number;
  color?: string;
  totalDots?: number;
}

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  percent,
  size = 120,
  color = "#00d1a0",
  totalDots = 500,
}) => {
  const radius = size / 2;
  const progressDots = Math.round((percent / 100) * totalDots);
  const dotSize = size * 0.06; // dot scales with size

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      {/* Circular dots */}
      {Array.from({ length: totalDots }).map((_, i) => {
        const angle = (i / totalDots) * 2 * Math.PI - Math.PI / 2;
        // start from top (-90°) for natural progress

        const x = radius + (radius - dotSize) * Math.cos(angle) - dotSize / 2;
        const y = radius + (radius - dotSize) * Math.sin(angle) - dotSize / 2;

        return (
          <View
            key={i}
            style={{
              width: dotSize,
              height: dotSize,
              borderRadius: dotSize / 2,
              backgroundColor: i < progressDots ? color : "#d9d9d9",
              position: "absolute",
              left: x,
              top: y,
            }}
          />
        );
      })}

      {/* Percentage text */}
      <View
        style={{
          position: "absolute",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Text style={{ fontSize: size * 0.25, fontWeight: 700, color: color }}>
          {percent}%
        </Text>
      </View>
    </View>
  );
};

export default CircularProgressBar;
